import { coreAgent } from "../../app/api/agent";
import { AlertDismissalRequestDto } from "./dtos/AlertDismissalDto";

export const createAlertDismissalRequest = (dto: AlertDismissalRequestDto) =>
  coreAgent.postRequest<AlertDismissalRequestDto>(`/alerts/dismiss`, dto);
